<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHinge from "../DesignerQuestionHardwareHinge.vue";
    import SynsealTileQuestion from "../mixin/synseal/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHinge,
            SynsealTileQuestion,
        ],
    }
</script>
